import { useCreateAdjustmentBase } from "./useCreateAdjustmentBase"

import type {
  CreateInventorySplitPalletsAdjustmentMutation,
  CreateInventorySplitPalletsAdjustmentMutationVariables,
  CreateSplitPalletsInput,
} from "@/graphql/codegen/graphql"
import { CreateInventorySplitPalletsAdjustmentDocument } from "@/graphql/codegen/graphql"

interface UseCreateSplitPalletsAdjustmentReturn {
  createAdjustment: (input: CreateSplitPalletsInput, comment?: string, document?: File) => Promise<boolean>
  isCreating: boolean
}

export const useCreateSplitPalletsAdjustment = (): UseCreateSplitPalletsAdjustmentReturn =>
  useCreateAdjustmentBase<
    CreateInventorySplitPalletsAdjustmentMutation,
    CreateInventorySplitPalletsAdjustmentMutationVariables,
    CreateSplitPalletsInput
  >({
    documentNode: CreateInventorySplitPalletsAdjustmentDocument,
    getOutput: (data) => data.inventoryAdjustment.splitPallets,
  })
